// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
});

/*
 * Help dialog for Clio Grow
 */

class ClioGrowHelp extends Component {
  state = {
  }
  
  render() {
    // eslint-disable-next-line    
    const { classes, open, onClose, anchorEl } = this.props;

    return (
      <React.Fragment>
        <MuiCore.Popover open={open}
                         anchorEl={anchorEl}
                         anchorOrigin={{
                           vertical: 'bottom',
                           horizontal: 'center',
                         }}
                         transformOrigin={{
                           vertical: 'top',
                           horizontal: 'center',
                         }}
                         onClose={onClose}>
          <ol style={{margin: 10}}>
            <li>Log into your <b>Clio Grow</b> account.</li>
            <li>Click on <b>Settings</b> at the bottom left.</li>
            <li>Click on <b>Integrations</b> near the bottom of the settings sections.</li>
            <li>Scroll down to the <b>Clio Grow Inbox</b> section and copy the Inbox Token.</li>
          </ol>
        </MuiCore.Popover>
      </React.Fragment>
    );
  }
}

ClioGrowHelp.propTypes = {
  open : PropTypes.bool.isRequired,
  onClose : PropTypes.func.isRequired,
  anchorEl : PropTypes.object,
}

ClioGrowHelp.defaultProps = {
  open : false,
}


export default withStyles(styles)(ClioGrowHelp);

